import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PartnerWallet} from '../../../dto/partnerWallet';

@Component({
  selector: 'app-invite-wallet-user-dialog',
  templateUrl: './invite-wallet-user-dialog.component.html',
  styleUrls: ['./invite-wallet-user-dialog.component.css']
})
export class InviteWalletUserDialogComponent implements OnInit {
  public title = 'Invite Wallet User';
  public text = 'Please enter the new user\'s e-mail address';

  public email: string;

  constructor(
    public dialogRef: MatDialogRef<InviteWalletUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) { }

  ngOnInit() {

    if (this.data != null) {
      this.email = this.data;
    }
  }

  onYesClick(): void {

    this.dialogRef.close(this.email);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }


}
